import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";

/**
 * Shared grid/report logic extracted from CancelledReportComponent,
 * NoshowPatientComponent and CheckedInPatientComponent. The previous inline
 * implementations were byte-identical (ignoring whitespace), so each method
 * here receives the calling component as `ctx` (context-delegation) and
 * mutates/reads the exact same fields the originals relied on, preserving
 * behaviour.
 */
@Injectable({ providedIn: "root" })
export class ReportGridService {
  checklength(value) {
    if (value && value.toString().length > 1) {
      return value;
    } else if (value) {
      return "0" + value;
    }
    return "0";
  }

  formatYmd(ctx: any, date: any) {
    const month1 = date.getMonth();
    return (
      date.getFullYear() +
      "-" +
      ctx.checklength(month1 + 1) +
      "-" +
      ctx.checklength(date.getDate())
    );
  }

  buildRowParams(ctx: any, obj: any) {
    const param: any = {};
    Object.keys(ctx.row).forEach((key, i) => {
      i = i + 1;
      param["param" + i] = obj[ctx.row["param" + i]];
    });
    return param;
  }

  convertutctolocal(datePipe: any, value: any, type: any) {
    let flag;
    if (value) {
      const datobj = value.split(" ");
      const utcdate = datobj[0] + "T" + datobj[1] + ".000Z";
      flag = new Date(utcdate);
      if (type === "time") {
        flag = datePipe.transform(flag, "hh:mm a");
      }
    }
    return flag;
  }

  getColumnOrder(ctx: any) {
    ctx.destroyComponent[
      "orderSubsciber"
    ] = ctx.supportService.gridSortingHeader.subscribe((result: any) => {
      if (result && (result["name"] || result["order"])) {
        ctx.pageOrder["sortColumn"] = result["name"];
        ctx.pageOrder["sortType"] = result["order"];
        ctx.getColumnData(ctx.pageOrder);
      }
    });
  }

  ngOnDestroy(ctx: any) {
    Object.keys(ctx.destroyComponent).forEach((key, i) => {
      if (ctx.destroyComponent[key]) {
        ctx.destroyComponent[key].unsubscribe();
      }
    });
  }

  pageChanged(ctx: any, event: any) {
    ctx.currentPage = event.page;
    ctx.pageOrder["pageNumber"] = event.page;
    ctx.getColumnData(ctx.pageOrder);
  }

  generate(ctx: any) {
    ctx.currentPage = 1;
    ctx.getColumnData(ctx.pageOrder);
  }

  blurOnChange(ctx: any, ev: any) {
    if (ev) {
      ctx.pageOrder["search"] = ev;
      ctx.pageOrder["pageNumber"] = 1;
      ctx.getColumnData(ctx.pageOrder, "blur");
    } else {
      ctx.pageOrder["search"] = "";
      ctx.pageOrder["pageNumber"] = 1;
      ctx.getColumnData(ctx.pageOrder, "blur");
    }
  }

  savePdfWithSaveAs(ctx: any, ev: any) {
    const pageOrder = ctx.clearCacheItem("savePdf");
    const param = pageOrder;
    param["offsetmin"] = new Date().getTimezoneOffset();
    ctx.api.getScheduleReportByType(param).subscribe((res: any) => {
      if (res && res["entity"] && res["entity"]["pdfFileURL"]) {
        const fileName = res["entity"]["pdfFileURL"].substring(
          res["entity"]["pdfFileURL"].lastIndexOf("/"),
          res["entity"]["pdfFileURL"].length
        );
        if (fileName) {
          saveAs(res["entity"]["pdfFileURL"], fileName);
        }
      } else {
        ctx.errorMessage = "No record found";
        setTimeout(() => {
          ctx.errorMessage = "";
        }, 5000);
      }
    });
  }
}
